import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '../../../../../../styles/Qtheme';

export const MenuLi = styled.li`
  height: 100%;
  position: relative;

  & * {
    transition: all 0.3s;
  }

  & ul {
    display: none;
    opacity: 0;
  }

  &:hover ul {
    opacity: 1;
    display: block;
  }
`;

export const Menu = styled(Link)`
  display: block;
  height: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.71px;
  color: ${({ theme }) => theme.text};
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 11000;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  @media (max-width: 1700px) {
    font-size: 14px;
  }
`;

export const SubMenuWrap = styled.div`
  border-radius: 10px;
  position: absolute;
  top: 10px;
  left: -22px;
  z-index: 10999;

  &.hover {
    z-index: 10998;
  }

  @media ${media.desktop} {
    display: none;
  }
`;

export const SubMenu = styled.ul`
  width: 380px;
  margin-top: 20px;
  padding: 4px;
  background-color: ${({ theme }) => theme.COLORS.DropdownBg};
  border: 1px solid ${({ theme }) => theme.COLORS.SubmenuBorder};
  border-radius: 8px;

  @media ${media.desktop} {
    display: none;
  }
`;

export const SubMenuList = styled.li`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 8px;
  transition: all 0.3s ease;

  a {
    display: block;
    width: 100%;
    height: 100%;
    padding: 15.5px 24px;
    gap: 10px;

    h4 {
      font-size: 16px;
      font-weight: 700;
      color: ${({ theme }) => theme.text};
      transition: color 0.3s ease;
    }

    p {
      margin-top: 5px;
      font-size: 14px;
      font-weight: 400;
      color: #b7b7b7;
      transition: color 0.3s ease;
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.DropdownHoverBg};

    a h4 {
      color: ${({ theme }) => theme.primary};
    }

    a p {
      color: ${({ theme }) => theme.text};
    }
  }
`;

export const SubMenuFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  color: ${({ theme }) => theme.COLORS.IconBorder};

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }
`;
